const hostName = process.env.REACT_APP_ALME_HOSTNAME;
//TODO find!ak axe all the alme shit
//
// const botpressHost =  process.env.REACT_APP_BOTPRESS_HOSTNAME;
// reusing above for now since alme is EOL for us, AK
const botpressHost = process.env.REACT_APP_ALME_HOSTNAME;
const apiHost = process.env.REACT_APP_API_HOST;
const serviceUri = `https://${process.env.REACT_APP_API_HOST}.execute-api.us-west-2.amazonaws.com/`;

const appPaths = {
  appPathTOS: "/TOS",
  appPathPrivacy: "/privacy",

  // Admin
  appPathAdmin: "/admin",
  appPathAdminPractice: "/admin/practice",
  appPathAdminPartner: "/admin/partner",
  appPathAdminPatient: "/admin/patient",
  appPathAdminProvider: "/admin/provider",
  appPathAdminAssessment: "/admin/assessment",
  appPathAdminBotpressTestHarness: "/admin/harness",
  appPathAdminBotpressConversations: "/admin/conversations",
  appPathAdminInvite: "/admin/invite",
  appPathAdminOrganization: "/admin/organization",

  // Provider
  appPathProvider: "/provider",
  appPathProviderBotpressTestHarness: "/provider/harness",
  appPathProviderBotpressConversations: "/provider/conversations",
  appPathProviderInvite: "/provider/invite",
  appPathProviderPatient: "/provider/patient",

  // Partner
  appPathPartner: "/partner",
  appPathPartnerBotpressTestHarness: "/partner/harness",
  appPathPartnerBotpressConversations: "/partner/conversations",
  appPathPartnerPatient: "/partner/patient",
  appPathPartnerChat: "/partner/chat",

  // Patient
  appPathPatient: "/patient",

  // omniOnboarding
  appPathOnboarding: "/onboarding",

  // botpress
  appPathHarness: "/harness",
  appPathMahalo: "/mahalo",
  appPathAvatar: "/avatars",
  appPathSheHub: "/shehub",
  appPathGotSoccer: "/got-soccer",
  appPathDemoSchoolsFirst: "/schoolsfirst",

  // omniOnboarding
  appPathUnsubscribe: "/unsubscribe",

  //Creator
  appPathCreator: "/creator",
  appPathCreatorOrganization: "/creator/organization",

  appPathCreatorDemoCoach: "/creator/demo/coach",
  appPathCreatorDemoOnboarding: "/demo/onboarding",
  appPathCreatorDemoPatient: "/demo/patient",
  appPathCreatorDemoTrials: "/demo/trials",
  appPathCreatorDemoNMHA: "/demo/nmha",
};

const mapDefaults = {
  lng: -88.6623,
  lat: 38.3038,
  zoom: 4.0,
};

const botpressGraphTypes = {
  usersGraph: "Daily Users",
  userTypesGraph: "User Types",
  messagesGraph: "Messages",
  sessionsGraph: "User Sessions",
  conversationTopicsGraph: "Conversation Topics",
  conversationSentimentGraph: "User Sentiment",
  overviewGraph: "Overview",
  llmGraph: "LLM Activity",
};

const graphTypes = {
  barGraph: "bar",
  lineGraph: "line",
  regressionGraph: "reg",
  controlLimitGraph: "control",
  doughnutChart: "doh",
};

const graphTimeRange = {
  long: "long",
  medium: "medium",
  short: "short",
};

const appEventIdStartConversation = "WelcomeUser";
const appEventIdFromReminder = "ConvoStarter_MedicationTracking_FromReminder";
const appEventIdNonAdherence = "ConvoStarter_MedicationTracking_NonAdherence";

const messageSource = {
  user: "user",
  server: "server",
};

const omniImputType = {
  text: "text",
  number: "number",
  currency: "currency",
  // date: "date",
  // phone: "phone",
  // time: "time",
  // scale: "scale",
  // email: "email",
  // bool: "bool",
};

const demoUserId = {
  userOne: "linda1",
  userTwo: "linda2",
  userThree: "linda3",
  userFour: "mae1",
  userFive: "mae2",
};

const demoUserArray = ["linda1", "linda2", "linda3", "mae1"];

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

var monthNamesLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const weekDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const weekDayNamesLong = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const feelingLabels = ["Default", "Horrible", "Bad", "Normal", "Good", "Great"];

const storageKeys = {
  currentTheme: "OmniThemeStorage",
  patientId: "OmnitPatientId",
  bpPatientId: "bpPatientId",
  bpConversation: "bpConversation",
  bpBot: "bpBotid",
};
const userSessionStorageKeys = {
  currentTheme: "OmniThemeStorage",
  conversationConfiguration: "OmniConversationConfiguration",
  awsGroup: "OmniAwsGroup",
  lastPartnerId: "OmniLastPartnerId",
  lastAssessmentType: "OmniLastAssessmentType",
  lastBotpressBotId: "OmniLastBotpressBotId",
};

const avatarType = {
  initials: "Initals",
  icon: "Icon",
  image: "Image",
};

const proactiveLaunchKeys = {
  input: "input",
  appEvent: "appevent",
  unit: "unit",
  state: "state",
};

const medicationForms = {
  aerosolspray: "aerosol, spray",
  injection: "injection",
  pill: "pill",
  tablet: "tablet",
};

const userGroups = {
  Creator: "Creator",
  Administrator: "Administrator",
  Provider: "Provider",
  Partner: "Partner",
  Patient: "Patient",
};

const feedbackStatus = [
  {
    value: 1,
    label: "New",
  },
  {
    value: 2,
    label: "Open",
  },
  {
    value: 3,
    label: "Closed",
  },
  {
    value: 4,
    label: "Retest",
  },
  {
    value: 5,
    label: "Blocked",
  },
];

const onboardingStatus = {
  initialStatus: "Waiting to onboard a user...",
  idBad: "Your ID is invalid.",
  idGood: "Your ID is valid.",
  idChecking: "Setting the Invite ID",
  inviteLoading: "Loading Invitation...",
  inviteLoaded: "Your Invidation is valid.",
  inviteFailed: "Failed to find your invitation.",
  onboardSuccessful: "Welcome Aboard!",
};

const inviteStatus = [
  {
    value: "created",
    label: "Created",
  },
  {
    value: "complete",
    label: "Onboarded",
  },
  {
    value: "unsubscribed",
    label: "Unsubscribed",
  },
];

const onboardingUserType = {
  administrator: "administrator",
  partner: "partner",
  patient: "patient",
  provider: "provider",
};

const inviteType = {
  single: "single",
  shared: "shared",
};

const inviteSurveyType = {
  shared: "shared", //admin managed shared
  personal: "personal", //individual single invites
  auto: "auto", //shared invites created for a user to disseminate
  comms: "comms", //individual single invites for email/sms selection
  all: "all", //all the invites
};

const omniRelationshipTypes = {
  //don't ever change these, they must match the enum in the json
  assessmentProctor: "assessmentProctor", //Used in assessmentODM: the proctor of an assessment
  assessmentSubject: "assessmentSubject", //Used in assessmentODM: the subject of an assessment
  patientPartner: "patientPartner", //Used in patientODM: a partner of the patient
  proxyPatient: "proxyPatient", //Used in patientODM: the partner this patient represents
  inviteOwner: "inviteOwner", //used in inviteODM: the partner this Invite is related to (i.e. created by)
  organizationSharedInvite: "organizationSharedInvite", //this is a default shared invite, created automagically
};

const omniRelationshipUserTypes = {
  administrator: "Administrator",
  partner: "Partner",
  patient: "Patient",
  provider: "Provider",
  campaign: "Campaign Results",
};

const userRaceOptions = [
  {
    value: "americanindianalaskanative",
    label: "American Indian/Alaska Native",
  },
  {
    value: "asian",
    label: "Asian",
  },
  {
    value: "blackafricanamerican",
    label: "Black or African American",
  },
  {
    value: "nativehawaiianotherpacificislander",
    label: "Native Hawaiian or other Pacific Islander",
  },
  {
    value: "white",
    label: "White",
  },
  {
    value: "biracialmultiracial",
    label: "Biracial or Multiracial",
  },
  {
    value: "prefernottosay",
    label: "Prefer not to say",
  },
  {
    value: "unsure",
    label: "I do not know",
  },
];

const userGenderOptions = [
  {
    value: "female",
    label: "Female",
  },
  {
    value: "male",
    label: "Male",
  },
  {
    value: "other",
    label: "Other",
  },
  {
    value: "prefernottosay",
    label: "Prefer not to say",
  },
];

const userEthnicityOptions = [
  {
    value: "mexicanchicano",
    label: "Mexican, Mexican Am., or Chicano",
  },
  {
    value: "puertorican",
    label: "Puerto Rican",
  },
  {
    value: "cuban",
    label: "Cuban",
  },
  {
    value: "other",
    label: "Other",
  },
  {
    value: "false",
    label: "Non-Hispanic",
  },
  {
    value: "prefernottosay",
    label: "Prefer not to say",
  },
  {
    value: "unsure",
    label: "I do not know",
  },
];

const contactTypes = {
  primaryCaregiver: "primaryCaregiver",
};

const reportTypeEnums = {
  patientsForOrganization: "patientsForOrganization",
  invites: "invites",
  communications: "communications",
  users: "users",
  assessments: "assessments",
};

const reportTypes = [
  {
    value: reportTypeEnums.invites,
    label: "Invite Report",
  },
  {
    value: reportTypeEnums.communications,
    label: "Communications Report",
  },
  {
    value: reportTypeEnums.users,
    label: "User Report",
  },
  // {
  //   value: "patientsForOrganization",
  //   label: "Candidate Report",
  // },
  // {
  //   value: "assessments",
  //   label: "Assessment Report",
  // },
  // comment out until needed
];

const supportedEmailSourceAddresses = {
  omnisciaDotHealth: "research@omniscia.health",
  omnisciaDotHealthCare: "research@omniscia.healthcare",
  omnisciaHealthDotCom: "research@omnisciahealth.com",
  omnisciaHealthDotHealthcare: "research@omnisciahealth.healthcare",
  OmnisciaHealthDotNet: "research@omnisciahealth.net",
};

const communicationTargets = [
  {
    value: "invitees",
    label: "Invitees",
  },
  {
    value: "partners",
    label: "Partners",
  },
];

const assessmentIDs = {
  //this is all assessment that have ever been supported,
  // never depricate anything so we support back compat,
  ar1001Prescreen: "ar1001Prescreen",
  omniHealthHistory: "omniHealthHistory",
  independentFunction: "IndependentFunction",
  phq9: "phq9",
  careFirstWeight: "careFirstWeight",
  pcrHairLoss: "pcrHairLoss",
  eos5Pillars: "eos5Pillars",
  eosBusinessInformation: "eosBusinessInformation",
  eosOnboarding: "eosOnboarding",
  omniMSOnboard: "omniMSOnboard",
  omniHealthHistoryDemo: "omniHealthHistoryDemo",
  omniMedicationReminderDemo: "omniMedicationReminderDemo",
  hyperOnboard: "hyperOnboard",
  defaultConversation: "defaultConversation", //ask ricky about this one
  botpressCUStandard: "botpressCUStandard",
  botpressDefault: "botpressDefault",

  botpressCUAccount: "botpressCUAccount",
  botpressCUAlertsSettings: "botpressCUAlertsSettings",
  botpressCUCards: "botpressCUCards",
  botpressCUDeposits: "botpressCUDeposits",
  botpressCUTransfersPayments: "botpressCUTransfersPayments",

  botpressFBBall: "botpressFBBall",
  botpressFBFoulsMisconduct: "botpressFBFoulsMisconduct",
  botpressFBMatchStructure: "botpressFBMatchStructure",
  botpressFBOffsides: "botpressFBOffsides",
  botpressFBPlayerTeams: "botpressFBPlayerTeams",
  botpressFBRestartsSetPieces: "botpressFBRestartsSetPieces",
};

//these are ONLY the currently supported types, Ones that are not depricated.
//The assessmentIDs above has the list of all that ever existed
const supportedAssessmentTypes = [
  {
    value: assessmentIDs.omniHealthHistory,
    label: "Health History",
    info: "Omniscia Health: Default Assessment",
  },
  {
    value: assessmentIDs.phq9,
    label: "PHQ-9",
    info: "Omniscia Health: Depression Severity",
  },
  {
    value: assessmentIDs.independentFunction,
    label: "Independent Function",
    info: "Northwest Neurological: Independent Function",
  },
  {
    value: assessmentIDs.careFirstWeight,
    label: "CareFirst Weight Loss",
    info: "Care First: Weight Loss",
  },
  {
    value: assessmentIDs.pcrHairLoss,
    label: "Premier Hair Loss",
    info: "Premier Clinical Research: Hair Loss",
  },
  {
    value: assessmentIDs.eosBusinessInformation,
    label: "Business Assessment",
    info: "Empire OS: Business Assessment",
  },
  {
    value: assessmentIDs.eos5Pillars,
    label: "Five Pillars",
    info: "Empire OS: Five Pillars",
  },
  {
    value: assessmentIDs.eosOnboarding,
    label: "Onboarding",
    info: "Empire OS: Onboarding",
  },

  {
    value: assessmentIDs.omniMSOnboard,
    label: "MS Onboarding",
    info: "Omniscia Health: MS Onboarding",
  },

  {
    value: assessmentIDs.omniMedicationReminderDemo,
    label: "Medication Reminder",
    info: "Omniscia Health: Medication Reminder",
  },

  {
    value: assessmentIDs.hyperOnboard,
    label: "HW Onboarding",
    info: "Hyperbaric Wellness: Onboarding",
  },
  {
    value: assessmentIDs.defaultConversation,
    label: "Depricated Conversation",
    info: "Depricated: Do not use",
  },
  {
    value: assessmentIDs.botpressDefault,
    label: "Default Questions",
    info: "Botpress: Default Questions",
  },
  {
    value: assessmentIDs.botpressCUStandard,
    label: "General User Questions",
    info: "Botpress: Standard Credit Union Questions",
  },
  {
    value: assessmentIDs.botpressCUAccount,
    label: "Accounts",
    info: "Botpress: CU Account Questions",
  },
  {
    value: assessmentIDs.botpressCUAlertsSettings,
    label: "Alerts & Settings",
    info: "Botpress: CU Alerts & Settings Questions",
  },
  {
    value: assessmentIDs.botpressCUCards,
    label: "Cards",
    info: "Botpress: CU Cards Questions",
  },
  {
    value: assessmentIDs.botpressCUDeposits,
    label: "Deposits",
    info: "Botpress: CU Deposits Questions",
  },
  {
    value: assessmentIDs.botpressCUTransfersPayments,
    label: "Transfers and Payments",
    info: "Botpress: CU Transfer Payments Questions",
  },
  {
    value: assessmentIDs.botpressFBBall,
    label: "Ball and Field",
    info: "Botpress: FB Ball and Field Questions",
  },
  {
    value: assessmentIDs.botpressFBOffsides,
    label: "Offsides Questions",
    info: "Botpress: FB Offsides Questions",
  },
  {
    value: assessmentIDs.botpressFBFoulsMisconduct,
    label: "Fouls and Misconduct",
    info: "Botpress: FB Fouls and Misconduct Questions",
  },
  {
    value: assessmentIDs.botpressFBMatchStructure,
    label: "Match Structure",
    info: "Botpress: FB Match Structure Questions",
  },
  {
    value: assessmentIDs.botpressFBPlayerTeams,
    label: "Player and Teams",
    info: "Botpress: FB Player and Teams Questions",
  },
  {
    value: assessmentIDs.botpressFBRestartsSetPieces,
    label: "Restarts and Set Pieces",
    info: "Botpress: FB Restarts and Set Pieces Questions",
  },
];

const userToDos = [
  {
    id: null,
    key: null,
    toDoType: "profileCompletion",
    incompleteText: "Complete your profile",
    completedText: "Update your profile",
    type: "profile",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: null,
    toDoType: "openInvitation",
    incompleteText: "Invite a friend",
    completedText: "Invite more Friends",
    type: "invitation",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: null,
    toDoType: "takeAnotherAssessment",
    incompleteText: "Take Another Assessment",
    completedText: "Take Another Assessment",
    type: "assessment",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  // {
  //   key: null,
  //   toDoType: "preScreenWorksheet",
  //   incompleteText: "Tell us about your Health History",
  //   completedText: "Take Another Health History Questionnaire",
  //   type: "assessment",
  //   description: "Click Here To",
  //   completeBy: null,
  //   isCompleted: false,
  //   completeDate: null,
  // },
  // {
  //   key: null,
  //   toDoType: "phq9Worksheet",
  //   incompleteText: "Take a PHQ9 Assessment",
  //   completedText: "Take Another PHQ9 Assessmen",
  //   type: "assessment",
  //   description: "Click Here To",
  //   completeBy: null,
  //   isCompleted: false,
  //   completeDate: null,
  // },
];

const organizationTypeEnums = {
  omnisicaHealth: "omnisicaHealth",
  empireOS: "empireOS",
  nsight: "nsight",
  hyperbaric: "hyperbaric",
  botpressTesting: "botpress",
};

const organizationTypes = [
  {
    value: organizationTypeEnums.omnisicaHealth,
    label: "Omniscia Health",
  },
  {
    value: organizationTypeEnums.empireOS,
    label: "Empire OS",
  },
  {
    value: organizationTypeEnums.nsight,
    label: "Nsight",
  },
  {
    value: organizationTypeEnums.hyperbaric,
    label: "Hyperbaric",
  },
  {
    value: organizationTypeEnums.botpressTesting,
    label: "Botpress",
  },
];

const empirePillarEnumes = {
  unknown: "unknown",
  leadership: "leadership",
  opertations: "operations",
  marketing: "marketing",
  finance: "finance",
  personnel: "personnel",
};

const empirePillarTypes = [
  {
    value: empirePillarEnumes.unknown,
    label: "Default",
  },
  {
    value: empirePillarEnumes.leadership,
    label: "Leadership",
  },
  {
    value: empirePillarEnumes.opertations,
    label: "Operations",
  },
  {
    value: empirePillarEnumes.marketing,
    label: "Marketing",
  },
  {
    value: empirePillarEnumes.finance,
    label: "Finance",
  },
  {
    value: empirePillarEnumes.personnel,
    label: "Personnel",
  },
];

const empireUserToDos = [
  {
    id: null,
    key: "eos5P",
    toDoType: "eos5Pillars",
    incompleteText: "Your 5 Pillars",
    completedText: "Your 5 Pillars",
    type: "assessment",
    businessPillar: "all",
    description: "Click to tell us about",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: "eosKPI1",
    toDoType: "eosKPI",
    incompleteText: "Your Cash On Hand KPI",
    completedText: "Your Cash On Hand KPI",
    type: "kpi",
    businessPillar: "finance",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Cash on Hand",
  },
  {
    id: null,
    key: "eosKPI2",
    toDoType: "eosKPI",
    incompleteText: "Gross Profit KPI",
    completedText: "Gross Profit KPI",
    type: "kpi",
    businessPillar: "finance",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Gross Profit",
  },
  {
    id: null,
    key: "eosBA",
    toDoType: "eosBusinessInformation",
    incompleteText: "Your Empire",
    completedText: "Your Empire",
    type: "assessment",
    businessPillar: "leadership",
    description: "Click to tell us about",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: "eosKPI3",
    toDoType: "eosKPI",
    incompleteText: "Weekly Bricks KPI",
    completedText: "Weekly Bricks KPI",
    type: "kpi",
    businessPillar: "leadership",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Bricks",
  },
  {
    id: null,
    key: "eosKPI4",
    toDoType: "eosKPI",
    incompleteText: "Weekly CCC KPI",
    completedText: "Weekly CCC KPI",
    type: "kpi",
    businessPillar: "leadership",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "CCC",
  },
  {
    id: null,
    key: "eosKPI5",
    toDoType: "eosKPI",
    incompleteText: "Weekly Cost Per Conversion KPI",
    completedText: "Weekly Cost Per Conversion KPI",
    type: "kpi",
    businessPillar: "marketing",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Cost Per Conversion",
  },
  {
    id: null,
    key: "eosKPI6",
    toDoType: "eosKPI",
    incompleteText: "Weekly Cost Per Lead KPI",
    completedText: "Weekly Cost Per Lead KPI",
    type: "kpi",
    businessPillar: "marketing",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Cost Per Lead",
  },
  {
    id: null,
    key: "eosKPI7",
    toDoType: "eosKPI",
    incompleteText: "Weekly Error Rate KPI",
    completedText: "Weekly Error Rate KPI",
    type: "kpi",
    businessPillar: "operations",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Error Rate",
  },
  {
    id: null,
    key: "eosKPI8",
    toDoType: "eosKPI",
    incompleteText: "Weekly Widgets Per Day KPI",
    completedText: "Weekly Widgets Per Day KPI",
    type: "kpi",
    businessPillar: "operations",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Widgets Per Day",
  },
  {
    id: null,
    key: "eosKPI9",
    toDoType: "eosKPI",
    incompleteText: "Weekly Attrition KPI",
    completedText: "Weekly Attrition KPI",
    type: "kpi",
    businessPillar: "personnel",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Attrition",
  },
  {
    id: null,
    key: "eosKPI10",
    toDoType: "eosKPI",
    incompleteText: "Weekly Training Hours KPI",
    completedText: "Weekly Training Hours KPI",
    type: "kpi",
    businessPillar: "personnel",
    description: "Click to update",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
    kpiName: "Training Hours",
  },
];

const nsightUserToDos = [
  {
    id: null,
    key: "n01",
    toDoType: "trackSymptoms",
    incompleteText: "Update Your Symptoms",
    completedText: "Symptom Tracking Complete",
    type: "symptoms",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: "n02",
    toDoType: "medication",
    incompleteText: "Complete Medication Reporting",
    completedText: "Medication Reporting Complete",
    type: "assessment",
    description: "Click here to",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: "n04",
    toDoType: "journal",
    incompleteText: "Add Journal Entry",
    completedText: "Journal Update Complete",
    type: "journal",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
  {
    id: null,
    key: "n05",
    toDoType: "phq9Assessment",
    incompleteText: "Take a PHQ9 assessment",
    completedText: "PHQ9 assessment Complete",
    type: "assessment",
    description: "Click Here To",
    completeBy: null,
    isCompleted: false,
    completeDate: null,
  },
];

const nsightUserToDosLearningTopics = [
  {
    id: null,
    key: "motivations",
    title: "Motivationals",
    imageLinks: [
      "https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/motivationsDifficultRoads.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/motivationsCreateLikeAnArtist.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/test/demo/motivationsPunchTodayInTheFace.png",
    ],
  },
];

const empireUserToDosLearningTopics = [
  {
    id: null,
    key: "businessPhases",
    title: "5 Phases of Business",
    imageLinks: [
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingStartup.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingPerseverance.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingViability.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingScaling.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingSuccession.png",
    ],
  },
  {
    id: null,
    key: "meetingStructure",
    title: "Meeting Structure",
    imageLinks: [
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingStrategy.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingOperation.png",
      "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/empireoperatingsystem/trainingImages/trainingCulture.png",
    ],
  },
];
// Sharing Vars

const defaultInvitationSharingVars = [
  {
    id: null,
    key: "email",
    invitationSubject: "Here's a link to a new research trial",
    invitationBody:
      "Check your eligibility for a new research trial using this online pre-screening tool:\r",
  },
  {
    id: null,
    key: "sms",
    invitationSubject: "",
    invitationBody:
      "Check%20your%20eligibility%20for%20a%20new%20research%20trial%20using%20this%20online%20pre-screening%20tool:%0d",
  },
  {
    id: null,
    key: "facebook",
    invitationSubject: "",
    invitationBody: "An invitation to a free clinical trial prescreening.",
  },
];

const hyperbaricInvitationSharingVars = [
  {
    id: null,
    key: "email",
    invitationSubject: "Here's a link for hyperbaric oxygen therapy",
    invitationBody:
      "Check your eligibility for hyperbaric oxygen therapy using this online tool:\r",
  },
  {
    id: null,
    key: "sms",
    invitationSubject: "",
    invitationBody:
      "Check%20your%20eligibility%20for%20hyperbaric%20oxygen%20therapy%20using%20this%20online%20tool:%0d",
  },
  {
    id: null,
    key: "facebook",
    invitationSubject: "",
    invitationBody: "An invitation for hyperbaric oxygen therapy",
  },
];

const botpressConversationOriginEnums = {
  emulator: "emulator",
  web: "web",
  portal: "poral",
  harness: "harness",
};

const botpressConfigTypeEnums = {
  aiModel: "aiModel",
};

const botpressConfigTypeTypes = [
  {
    value: botpressConfigTypeEnums.aiModel,
    label: "AI Model",
  },
];

const botpressConfigSubTypeEnums = {
  aiModel: "conversationalAi",
  ragAi: "ragAi",
};

const botpressConfigSubTypeTypes = [
  {
    value: botpressConfigSubTypeEnums.aiModel,
    label: "UX AI",
  },
  {
    value: botpressConfigSubTypeEnums.ragAi,
    label: "RAG AI",
  },
];

const fileFormatEnums = {
  csv: "csv",
  excel: "xlsx",
  text: "txt",
  json: "json",
};

const fileFormatTypes = [
  {
    value: fileFormatEnums.csv,
    label: "CSV",
  },
  {
    value: fileFormatEnums.excel,
    label: "Excel",
  },
  {
    value: fileFormatEnums.text,
    label: "Text",
  },
  {
    value: fileFormatEnums.json,
    label: "JSON",
  },
];

const theExports = {
  contactTypes,
  omniRelationshipTypes,
  omniRelationshipUserTypes,
  userEthnicityOptions,
  userGenderOptions,
  userRaceOptions,
  feelingLabels,
  mapDefaults,
  hostName,
  messageSource,
  omniImputType,
  storageKeys,
  avatarType,
  appEventIdStartConversation,
  appEventIdFromReminder,
  appEventIdNonAdherence,
  demoUserId,
  appPaths,
  proactiveLaunchKeys,
  botpressGraphTypes,
  graphTypes,
  graphTimeRange,
  monthNames,
  monthNamesLong,
  weekDayNames,
  weekDayNamesLong,
  serviceUri,
  medicationForms,
  botpressHost,
  apiHost,
  userGroups,
  demoUserArray,
  userSessionStorageKeys,
  onboardingStatus,
  onboardingUserType,
  inviteType,
  reportTypes,
  communicationTargets,
  inviteSurveyType,
  inviteStatus,
  reportTypeEnums,
  assessmentIDs,
  supportedAssessmentTypes,
  userToDos,
  supportedEmailSourceAddresses,
  organizationTypes,
  organizationTypeEnums,
  empirePillarEnumes,
  empirePillarTypes,
  empireUserToDos,
  empireUserToDosLearningTopics,
  nsightUserToDos,
  nsightUserToDosLearningTopics,
  defaultInvitationSharingVars,
  hyperbaricInvitationSharingVars,
  feedbackStatus,
  fileFormatEnums,
  fileFormatTypes,
  botpressConfigTypeTypes,
  botpressConfigTypeEnums,
  botpressConfigSubTypeEnums,
  botpressConfigSubTypeTypes,
  botpressConversationOriginEnums,
};

export default theExports;
